import React from 'react'

import { Carousel as AntCarousel, CarouselProps } from 'antd'
import { CarouselRef } from 'antd/lib/carousel'

function Carousel(props: CarouselProps & React.RefAttributes<CarouselRef> & { carouselRef: React.Ref<CarouselRef> }) {
  return <AntCarousel ref={props.carouselRef} {...props} />
}

export default Carousel
